//展示管理
import http from '../jslibs/axios/http';

// 课程列表
export const getCourseList = data => http.get('/cms/Course', data);
// 新增课程
export const addCourse = data => http.post('/cms/Course', data);
//编辑课程
export const updateCourse = data => http.put('/cms/Course/' + data.uuid, data);
//课程详情
export const getCourseDetail = data => http.get('/cms/Course/' + data.uuid);
//删除课程
export const deleteCourse = data => http.delete('/cms/Course/' + data.uuid);
//课程上下架
export const updateCourseVis = data => http.put('/cms/CourseVis/' + data.uuid,data);
//设置/移除
export const updateCourseRecommend = data => http.put('/cms/CourseRecommend/' + data.uuid,data);


// 课程分类列表
export const getCourseCateList = data => http.get('/cms/CourseCate', data);
// 新增课程分类
export const addCourseCate = data => http.post('/cms/CourseCate', data);
//编辑课程分类
export const updateCourseCate = data => http.put('/cms/CourseCate/' + data.uuid, data);
//课程分类详情
export const getCourseCateDetail = data => http.get('/cms/CourseCate/' + data.uuid);
//删除课程分类
export const deleteCourseCate = data => http.delete('/cms/CourseCate/' + data.uuid);


// 课程下发列表
export const getSendCourseList = data => http.get('/cms/SendCourse', data);
// 新增课程下发
export const addSendCourse = data => http.post('/cms/SendCourse', data);
//删除课程下发
export const deleteSendCourse = data => http.delete('/cms/SendCourse/' + data.uuid);


// 课程评论列表
export const getCourseOrderEvaluate = data => http.get('/cms/CourseOrderEvaluate', data);
// 课程评论审核
export const putCourseOrderEvaluate = data => http.put('/cms/CourseOrderEvaluate/'+data.uuid, data);

